'use strict';
module.exports = require('./lib/client/phone');



//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/griffin-paypal/phone.js
// module id = 350
// module chunks = 6